import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
import LoginHeader from '../Login_header';

const Rep_mtm = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [tillDate, setTillDate] = useState(new Date());

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [generateType, setGenerateType] = useState("D")

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_MTM_HO'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleGenerate = () => {
        $(".loader").show();

        if (!Common.validateFinYear(Common.dateYMD(tillDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        const obj = {
            tillDate: Common.dateYMD(tillDate),
            tillDateDMY: Common.dateDMY(tillDate),
        };
        Common.callDownloadApiPost1(Common.apirepmtmHO, "post", [sid, "downloadmtm", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        });
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report MTM</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Row>
                        <Row><h4>Date</h4></Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={tillDate}
                                    onChange={(date) => setTillDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown

                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row><h4>Report View</h4></Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_mtm;